import slugify from 'slugify';

export default function getReportReviewUrl(userName: string | null, agencySlug: string, reviewUuid: string) {
  const reviewReportBaseUrl = 'https://sortlist1.typeform.com/to/GxcWiNoZ';
  const userNameSlugify = userName ? slugify(userName) : '';

  return `${reviewReportBaseUrl}#agency_slug=${agencySlug}&reviewers_name=${userNameSlugify}&review_uuid=${reviewUuid}`;
}
